/**
 * 商品詳細：平面図・立面図の画像クリックでポップアップ表示（画像のみ）
 */
function initKitDetailDrawingsModal() {
  const modal = document.getElementById('kit-detail-drawings-modal');
  const drawings = document.querySelector('.p-kit-detail-drawings__body');
  if (!modal || !drawings) return;

  const modalImg = modal.querySelector('.p-kit-bitooku-modal__img');
  const modalCaption = modal.querySelector('.p-kit-bitooku-modal__caption');
  const closeTriggers = modal.querySelectorAll('[data-kit-detail-drawings-modal-close]');

  if (!modalImg || !modalCaption) return;

  let lastFocused = null;

  const getFigureLabel = (figure) => {
    const item = figure.closest('.p-kit-detail-drawings__elevations-item');
    if (item) {
      const title = item.querySelector('.p-kit-detail-drawings__elevations-title');
      if (title) return title.textContent.trim();
    }

    const img = figure.querySelector('img');
    if (img && img.alt) return img.alt.trim();

    return '図面';
  };

  const openModalFromMedia = ({ src, alt, label, trigger }) => {
    if (!src) return;

    lastFocused = trigger;

    modalImg.src = src;
    modalImg.alt = alt || label || '';
    modalCaption.textContent = label || alt || '';

    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    const closeBtn = modal.querySelector('.p-kit-bitooku-modal__close');
    if (closeBtn) closeBtn.focus();
  };

  const openModalFromFigure = (figure) => {
    const img = figure.querySelector('img');
    if (!img) return;

    openModalFromMedia({
      src: img.currentSrc || img.src,
      alt: img.alt || '',
      label: getFigureLabel(figure),
      trigger: figure,
    });
  };

  const openModalFromNavBtn = (button) => {
    const src = button.getAttribute('data-kit-detail-drawings-modal-src');
    const label = button.getAttribute('data-kit-detail-drawings-modal-label') || '';

    openModalFromMedia({
      src,
      alt: label,
      label,
      trigger: button,
    });
  };

  const closeModal = () => {
    modal.hidden = true;
    document.body.style.overflow = '';
    modalImg.removeAttribute('src');

    if (lastFocused) {
      lastFocused.focus();
    }
    lastFocused = null;
  };

  drawings.addEventListener('click', (event) => {
    const navBtn = event.target.closest('[data-kit-detail-drawings-modal-src]');
    if (navBtn && drawings.contains(navBtn)) {
      openModalFromNavBtn(navBtn);
      return;
    }

    const figure = event.target.closest('.p-kit-detail-drawings__figure');
    if (!figure || !drawings.contains(figure)) return;

    openModalFromFigure(figure);
  });

  drawings.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const navBtn = event.target.closest('[data-kit-detail-drawings-modal-src]');
    if (navBtn && drawings.contains(navBtn)) {
      event.preventDefault();
      openModalFromNavBtn(navBtn);
      return;
    }

    const figure = event.target.closest('.p-kit-detail-drawings__figure');
    if (!figure || !drawings.contains(figure)) return;

    event.preventDefault();
    openModalFromFigure(figure);
  });

  drawings.querySelectorAll('.p-kit-detail-drawings__figure').forEach((figure) => {
    const label = getFigureLabel(figure);

    figure.setAttribute('tabindex', '0');
    figure.setAttribute('role', 'button');
    figure.setAttribute('aria-label', `${label}を拡大表示`);
  });

  drawings.querySelectorAll('[data-kit-detail-drawings-modal-src]').forEach((button) => {
    const label = button.getAttribute('data-kit-detail-drawings-modal-label') || '立面図';

    button.setAttribute('aria-label', `${label}を拡大表示`);
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
}

/**
 * 商品詳細：価格表をマウスドラッグで横スクロール
 */
function initKitDetailPriceTableDragScroll() {
  const wrap = document.querySelector('.p-kit-detail-price__table-wrap');
  if (!wrap) return;

  let isDragging = false;
  let startX = 0;
  let scrollLeftStart = 0;

  const hasOverflow = () => wrap.scrollWidth > wrap.clientWidth + 1;

  const updateScrollable = () => {
    wrap.classList.toggle('is-scrollable', hasOverflow());

    if (!hasOverflow()) {
      isDragging = false;
      wrap.classList.remove('is-dragging');
    }
  };

  const endDrag = () => {
    if (!isDragging) return;

    isDragging = false;
    wrap.classList.remove('is-dragging');
  };

  wrap.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse') return;
    if (event.button !== 0) return;
    if (!hasOverflow()) return;
    if (event.target.closest('a, button, input, select, textarea, label')) return;

    isDragging = true;
    startX = event.clientX;
    scrollLeftStart = wrap.scrollLeft;
    wrap.classList.add('is-dragging');
    wrap.setPointerCapture(event.pointerId);
    event.preventDefault();
  });

  wrap.addEventListener('pointermove', (event) => {
    if (!isDragging) return;

    wrap.scrollLeft = scrollLeftStart - (event.clientX - startX);
    event.preventDefault();
  });

  wrap.addEventListener('pointerup', endDrag);
  wrap.addEventListener('pointercancel', endDrag);
  wrap.addEventListener('lostpointercapture', endDrag);

  updateScrollable();
  window.addEventListener('resize', updateScrollable);
  window.addEventListener('load', updateScrollable);
}

/**
 * 商品詳細：仕様アコーディオン（CSS Grid 0fr / 1fr + clip-path）
 */
function initKitDetailSpecificationsAccordion() {
  const buttons = document.querySelectorAll('.p-kit-detail-specifications .p-kit-detail-specifications__item-trigger');
  if (!buttons.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const accordionMs = 400;

  buttons.forEach((button) => {
    const bodyId = button.getAttribute('aria-controls');
    const body = bodyId ? document.getElementById(bodyId) : null;
    if (!body) return;

    let closeTimer = null;

    const getTitleText = () => {
      const title = button.querySelector('.p-kit-detail-specifications__item-title');
      return title ? title.textContent.trim() : '仕様';
    };

    const setAria = (isExpanded) => {
      const titleText = getTitleText();
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        isExpanded ? `${titleText}の詳細を閉じる` : `${titleText}の詳細を表示`
      );
    };

    const clearCloseTimer = () => {
      if (closeTimer === null) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    const openBody = () => {
      clearCloseTimer();
      body.hidden = false;
      setAria(true);

      if (prefersReducedMotion) {
        body.classList.add('is-open');
        return;
      }

      requestAnimationFrame(() => {
        body.classList.add('is-open');
      });
    };

    const closeBody = () => {
      clearCloseTimer();
      setAria(false);
      body.classList.remove('is-open');

      if (prefersReducedMotion) {
        body.hidden = true;
        return;
      }

      const finishClose = () => {
        if (button.getAttribute('aria-expanded') !== 'false') return;
        body.hidden = true;
      };

      const onEnd = (event) => {
        if (event.propertyName !== 'grid-template-rows') return;
        body.removeEventListener('transitionend', onEnd);
        clearCloseTimer();
        finishClose();
      };

      body.addEventListener('transitionend', onEnd);
      closeTimer = window.setTimeout(() => {
        closeTimer = null;
        body.removeEventListener('transitionend', onEnd);
        finishClose();
      }, accordionMs + 50);
    };

    setAria(false);
    body.hidden = true;
    body.classList.remove('is-open');

    button.addEventListener('click', () => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        closeBody();
      } else {
        openBody();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initKitDetailDrawingsModal();
  initKitDetailPriceTableDragScroll();
  initKitDetailSpecificationsAccordion();
});
